import { RevenueItem } from 'src/app/revenue/shared/revenue-items/revenue-item.model';
import { RevenueItemService } from 'src/app/revenue/shared/revenue-items/revenue-item.service';
import { SelectItem } from 'primeng/api';
import { SalesOpportunityService } from '../shared/sales-opportunity.service';
import { SalesOpportunitySearchDto, initializedSalesOpportunitySearchDto } from '../shared/dto/sales-opportunity-search.dto';
import { UserService } from 'src/app/users/shared/user.service';
import { Component, OnInit, Input, ViewEncapsulation, OnChanges, SimpleChanges, EventEmitter, Output } from '@angular/core';
import { FieldValueOperatorEnum } from 'src/app/shared/search-expression/field-value-operator.enum';
import { TranslationService } from 'src/app/shared';

@Component({
  selector: 'wl-sales-opportunity-search-params',
  templateUrl: './sales-opportunity-search-params.component.html',
  styleUrls: ['./sales-opportunity-search-params.component.less'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class SalesOpportunitySearchParamsComponent implements OnInit, OnChanges {
  @Input()
  get searchParams() {
    return this._searchParams;
  }
  set searchParams(value: SalesOpportunitySearchDto) {
    this._searchParams = value;
    this.searchParamsChange.emit(this._searchParams);
  }
  @Output() searchParamsChange = new EventEmitter<SalesOpportunitySearchDto>();
  assignedToUserItems: SelectItem[];
  probabilityItems: SelectItem[];
  fieldOperatorItems: SelectItem[];
  allRevenueItems: RevenueItem[];
  selectedRevenueItems: RevenueItem[];
  revenueItemSearchResults: RevenueItem[];
  includeClosed = false;
  includeLost = false;

  private _searchParams: SalesOpportunitySearchDto;

  constructor(
    private _userService: UserService,
    private _salesOpportunityService: SalesOpportunityService,
    private _revenueItemService: RevenueItemService
  ) {
    this.searchParams = initializedSalesOpportunitySearchDto();
  }

  ngOnInit(): void {
    this._userService.getActiveUsers().then((users) => {
      this.assignedToUserItems = users.map<SelectItem>((user) => {
        return { label: user.UserName, value: user.UserNum };
      });
    });

    this._salesOpportunityService.searchSalesOpportunityProbabilities().then((probabilities) => {
      this.probabilityItems = probabilities.Result?.map<SelectItem>((probability) => {
        return { label: probability.Descr, value: probability.Probability };
      });
    });

    this._revenueItemService.getAllRevenueItems().then((items) => {
      this.allRevenueItems = items;
    });
  }

  ngOnChanges(simpleChanges: SimpleChanges) {
    if (simpleChanges.searchParams && this.searchParams) {
      if (this.searchParams.Closed === null) {
        this.includeClosed = true;
      } else if (this.searchParams.Closed === false) {
        this.includeClosed = false;
      }

      if (this.searchParams.Lost === null) {
        this.includeLost = true;
      } else if (this.searchParams.Lost === false) {
        this.includeLost = false;
      }
    }
  }

  searchRevenueItems(event: any) {
    this.revenueItemSearchResults = this.allRevenueItems
      ?.filter((ri) => ri.ItemName.toLowerCase().includes(event.query?.toLowerCase()))
      .filter((x) => !this.selectedRevenueItems?.find((y) => x === y));
  }

  syncItems() {
    this.searchParams.RevenueItemNums = this.selectedRevenueItems.map((x) => x.ItemNum);
  }

  syncCheckboxes() {
    this.searchParams.Closed = this.includeClosed ? null : false;
    this.searchParams.Lost = this.includeLost ? null : false;
  }
}
